/**
 * Copy juridica e de privacidade do aviso local-first.
 * Toda string visivel ao usuario no aviso de privacidade fica aqui.
 * Privacidade: sem dados pessoais neste modulo.
 */

export interface PrivacyNoticeCopy {
  title: string;
  intro: string;
  bulletPoints: string[];
  legalDisclaimer: string;
  acceptButtonLabel: string;
}

export function getPrivacyNoticeCopy(): PrivacyNoticeCopy {
  return {
    title: 'Como seus dados são tratados',
    intro: 'Antes de carregar os arquivos, leia como este diagnóstico funciona:',
    bulletPoints: [
      'Os arquivos AFD/AEJ são processados localmente no seu navegador.',
      'Nenhum arquivo ou dado pessoal é enviado para servidores externos.',
      'Não há persistência entre sessões: ao fechar a aba, os dados são descartados.',
      'Os resultados exibidos são indicadores técnicos, não pareceres jurídicos.',
      'CPFs, nomes e CNPJs não aparecem nos relatórios exportados.',
    ],
    legalDisclaimer:
      'Este diagnóstico é um indicador técnico. Não constitui auditoria trabalhista nem parecer jurídico.',
    acceptButtonLabel: 'Entendi, continuar',
  };
}

export function hasAcceptedPrivacyNotice(privacyAccepted: boolean): boolean {
  return privacyAccepted;
}
